import {Team} from "../models/Team";

export const teamChanges = (savedTeams: Team[], teams: Team[]) => {
    const isTeamPairingChanged = (t1: Team, t2: Team) => (t1.no_pair !== t2.no_pair);

    return teams.filter((team, index) => isTeamPairingChanged(team, savedTeams[index]));
};
